import { RoleEnum } from '@app/_api/enums/role.enum';

export class RolePermission {
  readonly authorized: boolean;

  constructor(authorizedRoles: RoleEnum[], currentRole?: RoleEnum) {
    this.authorized = currentRole ? authorizedRoles.includes(currentRole) : false;
  }
}
